import { Logger } from '@frontend/logger';
import { useCallback, useEffect, useState } from 'react';

import { HUMAN_READABLE, RELEASE_DATE, UNIQUE_SHA, VERSION_NUMBER } from '../../../version';

export function useVersionBadge() {
    const [popoverOpen, setPopoverOpen] = useState(false);

    useEffect(() => {
        Logger.log('Version info', {
            humanReadable: HUMAN_READABLE,
            versionNumber: VERSION_NUMBER,
            uniqueSha: UNIQUE_SHA,
            releaseDate: RELEASE_DATE
        });
    }, []);

    const togglePopover = useCallback(() => {
        setPopoverOpen((prev) => !prev);
    }, []);

    const closePopover = useCallback(() => {
        setPopoverOpen(false);
    }, []);

    return {
        popoverOpen,
        humanReadable: HUMAN_READABLE.replace(/_/g, ' '),
        versionNumber: VERSION_NUMBER,
        uniqueSha: UNIQUE_SHA,
        releaseDate: RELEASE_DATE,
        togglePopover,
        closePopover
    };
}
